<template id="travel-agency-list-cell">
  <div class="list-cell-box" @click="onTapCell">
    <!-- 主要内容 -->
    <div class="main-box">
      <!-- logo -->
      <img class="company-logo" :src="item.photoPath" alt="">
      <!-- content -->
      <div class="content-box">
        <p class="company-name">{{ item.name }}</p>
        <!-- 标签 -->
        <div class="tag-box">
          <!-- 旅行社类型: 总社/分社/网点 -->
          <div v-if="agencyType[item.isParent] != null &&  agencyType[item.isParent].length > 0" class="gray-tag">{{ agencyType[item.isParent] }}</div>
          <!-- 注册情况 -->
          <div class="gray-tag">{{ item.state == 1 || item.state == 3 ? '已注册':'未注册' }}</div>
          <!-- 审核状态 -->
          <div class="green-tag">{{ item.stateStr }}</div>
        </div>
        <!-- 所属区域 -->
        <div class="area-name">所属区域：{{ item.cityName }}</div>
        <!-- 许可证 -->
        <div class="permission-box">
          <div class="permission-title">许可证状态：</div>
          <p v-if="item.travelStatus == 1" class="permission-value green">正常</p>
          <p v-else-if="item.travelStatus == 2" class="permission-value red">吊销</p>
          <p v-else-if="item.travelStatus == 3" class="permission-value blue">注销</p>
          <p v-else-if="item.travelStatus == 4" class="permission-value orange">撤销</p>
        </div>
      </div>
    </div>
    <!-- 附加内容 -->
    <div v-if="item.isBlacklist != 0 || item.isSupervise !=0" class="addtional-box">
      <!-- 重点监管 -->
      <div v-if="item.isSupervise != 0" class="addtional-item-box">
        <img src="../../../assets/travelAgency/icon_supervise.png" alt="" class="icon">
        <p class="text orange">重点关注</p>
      </div>
      <!-- 黑名单 -->
      <div v-if="item.isBlacklist != 0" class="addtional-item-box">
        <img src="../../../assets/travelAgency/icon_blacklist.png" alt="" class="icon">
        <p class="text red">黑名单监管</p>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'list-cell',
        props: {
          item: {
            type: Object,
            default: {}
          }
        },
        data () {
            return {
              agencyType: ['', '总社', '分社', '网点'],
            }
        },
        methods: {
          onTapCell () {
            this.$emit( 'onTapCell', this.item )
          }
        }
    }
</script>

<style scoped lang="less">
@vv: 3.75vw;
.list-cell-box {
  background-color: #fff;
  border-radius: 4px;
  margin: 12/@vv 12/@vv;
  .main-box {
    display: flex;
    padding-left: 16/@vv;
    padding-top: 16/@vv;
    padding-right: 16/@vv;
    padding-bottom: 12/@vv;
    .company-logo {
      width: 48/@vv;
      height: 48/@vv;
    }
    .content-box {
      margin-left: 12/@vv;
      .company-name {
        font-size: 16/@vv;
        font-weight: 600;
        color: #1e2226;
      }
      .tag-box {
        display: flex;
        margin-top: 8/@vv;
        .gray-tag {
          border-radius: 2px;
          border: 0.5px solid #71747a;
          padding: 2/@vv 4/@vv;
          font-size: 12/@vv;
          color: #71747a;
          margin-right: 6/@vv;
        }
        .green-tag {
          border-radius: 2px;
          border: 0.5px solid #36b374;
          padding: 2/@vv 4/@vv;
          font-size: 12/@vv;
          color: #36b374;
          margin-right: 6/@vv;
        }
      }
      .area-name {
        font-size: 14/@vv;
        color: #71747a;
        margin-top: 18/@vv;
      }
      .permission-box {
        display: flex;
        margin-top: 6/@vv;
        .permission-title {
          font-size:  14/@vv;
          color: #71747a;
        }
        .permission-value {
          font-size: 14/@vv;
          font-weight: 500;
        }
        .green {
          color: #36b374;
        }
        .red {
          color: #ef5948;
        }
        .blue {
          color:#1673d3
        }
        .orange {
          color: #ef750a;
        }
      }
    }
  }
  .addtional-box {
    display: flex;
    background-color: #fff6f5;
    height: 40/@vv;
    align-items: center;
    padding-left: 20/@vv;
    .addtional-item-box {
      display: flex;
      margin-right: 20/@vv;
      .icon {
        width: 14/@vv;
        height: 14/@vv;
      }
      .text {
        font-size: 14/@vv;
        margin-left: 5/@vv;
      }
      .orange {
        color: #ef750a;
      }
      .red {
        color: #fc523f;
      }
    }
  }
}
</style>
